import { render } from "./ComplianceTrends.vue?vue&type=template&id=4298e6d6&scoped=true"
import script from "./ComplianceTrends.vue?vue&type=script&lang=js"
export * from "./ComplianceTrends.vue?vue&type=script&lang=js"

import "./ComplianceTrends.vue?vue&type=style&index=0&id=4298e6d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4298e6d6"]])

export default __exports__